import vuePlayer from './vue-player.vue'

const playerPlugin = {}
export default playerPlugin.install = (Vue, options) => {
	Vue.component('vue-player', vuePlayer)
}



// WEBPACK FOOTER //
// ./src/player/vue-player.js